import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { regionalRateService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import { RegionalRateForm } from '../components/RegionalRateForm';
import { IRegionalRate } from '../types';

const initRegionalRate: IRegionalRate = {
  id: null,
  code: null,
  description: null,
  rate: null
};

export const CreateRegionalRate = () => {
  const translationPrefix = 'pages.regional-rate.new';

  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const createRegionalRate = async (values) => {
    dispatch(loadingActions.startLoading());
    regionalRateService.add(values).then(() => {
      toast.crud.successCreate('Tariffa', 'f');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <RegionalRateForm regionalRate={initRegionalRate} onSubmit={createRegionalRate} />
    </TenantPage>
  );
};

export default CreateRegionalRate;
